import { ReactComponent as CheckCircleIcon } from '../../../assets/icons/checkbox-circle-fill.svg';
import translation from '../../../shared/data/translation/hu_HU';
import classes from './LoginViewDetails.module.scss';

export const LoginViewDetails = () => {
  const registrationDetailsList = [
    translation.login.item1,
    translation.login.item2,
    translation.login.item3,
    translation.login.item4,
  ];

  return (
    <div className={classes.details}>
      {registrationDetailsList.map((item, index) => (
        <div
          key={index}
          className={classes.detailsRow}
        >
          <CheckCircleIcon className={classes.detailsRowIcon} />
          <span className={classes.detailsRowText}>{item}</span>
        </div>
      ))}
    </div>
  );
};
